<div mat-dialog-title>{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.TITLE' | i18n }}</div>
<form [formGroup]="mailOnsForm" (ngSubmit)="onSubmit()">
    <div mat-dialog-content>
        <div class="row mb-2">
            <div class="col-12">
                <baas-remark-list>
                    @if (showSubjectInvalidValidation()) {
                    <baas-remark type="blocking">{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.SUBJECT_INVALID' | i18n }}</baas-remark>
                    }
                </baas-remark-list>
            </div>
        </div>
        <div class="row">
            <div class="col-6 col-md-6">
                <mat-form-field class="w-100 mat-form-field-readonly">
                    <mat-label>{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.USER.NAME' | i18n }}</mat-label>
                    <input type="text" matInput formControlName="name" readonly />
                </mat-form-field>
            </div>
            <div class="col-6 col-md-6">
                <mat-form-field class="w-100">
                    <mat-label>{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.CLIENT' | i18n }}</mat-label>
                    <input type="text" matInput formControlName="client" maxlength="80" />
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field class="w-100">
                    <mat-label>{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.USER.EMAIL' | i18n }}</mat-label>
                    <input type="email" matInput formControlName="email" />
                </mat-form-field>
            </div>
            <div class="col-6 col-md-6">
                <mat-form-field class="w-100">
                    <mat-label>{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.USER.PHONE' | i18n }}</mat-label>
                    <input type="text" matInput formControlName="phone" />
                </mat-form-field>
            </div>
            <div class="col-6 col-md-6">
                <mat-form-field class="w-100">
                    <mat-label>{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.USER.MOBILE_PHONE' | i18n }}</mat-label>
                    <input type="text" matInput formControlName="mobilePhone" />
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <mat-form-field class="w-100">
                    <mat-label>{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.SUBJECT' | i18n }}</mat-label>
                    <input type="text" matInput formControlName="subject" maxlength="255" />
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field class="w-100">
                    <mat-label>{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.BODY' | i18n }}</mat-label>
                    <textarea
                        matInput
                        formControlName="body"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="4"
                        cdkAutosizeMaxRows="8"
                        maxlength="1000"
                    ></textarea>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-1">
            <div class="col-12">
                <div class="lv-form-field">
                    <label for="attachments">{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.ATTACHMENTS' | i18n }}</label>
                    <mat-card>
                        <mat-card-content>
                            <ul>
                                @for (file of files(); track $index) {
                                <li class="d-flex flex-column">
                                    <mat-progress-bar [value]="file.progress" [color]="file.color" [matTooltip]="file.tooltip"> </mat-progress-bar>
                                    <div class="d-flex align-items-center">
                                        <span id="file-label"> {{ file.name }} </span>
                                        <button
                                            type="button"
                                            mat-icon-button
                                            [matTooltip]="'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.DELETEFILE' | i18n"
                                            (click)="deleteFile(file.name)"
                                            [attr.aria-label]="'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.DELETEFILE' | i18n"
                                            style="border: none !important"
                                        >
                                            <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                                        </button>
                                    </div>
                                </li>
                                }
                            </ul>
                        </mat-card-content>
                        <mat-card-actions>
                            <button type="button" matButton (click)="onFileUploadClick()">
                                {{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.SELECTFILES' | i18n }}
                            </button>
                        </mat-card-actions>
                    </mat-card>
                    <input
                        type="file"
                        #fileUpload
                        id="attachments"
                        formControlName="attachments"
                        name="attachments"
                        multiple="multiple"
                        style="display: none"
                    />
                </div>
            </div>
        </div>

        @if (sendError()) {
        <div style="display: flex" class="mt-2">
            <mat-icon
                role="img"
                fontset="fa"
                class="mat-icon notranslate mat-error fa-times-circle fa mat-icon-no-color"
                aria-hidden="true"
                data-mat-icon-type="font"
                data-mat-icon-name="fa-times-circle"
                data-mat-icon-namespace="fa"
                fonticon="fa-times-circle"
            ></mat-icon>
            <span>{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.SEND_ERROR_MAIL' | i18n }}</span>
        </div>
        }
        <p>Velden met een asterisk (*) zijn verplicht.</p>
        <div class="row">
            <div class="col-12">
                <p>{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.NOTIFICATION' | i18n }}</p>
            </div>
        </div>
    </div>
    <mat-dialog-actions align="end">
        <button matButton="filled" type="submit" [disabled]="inVerzending()">{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.SEND' | i18n }}</button>
        <button matButton type="button" mat-dialog-close [disabled]="inVerzending()">{{ 'DOMAIN_STARTSCHERM.MAIL_ONS_DIALOG.FORM.CANCEL' | i18n }}</button>
    </mat-dialog-actions>
</form>
